export enum SpinnerView {
  Condition = 'CONDITION',
  Features = 'FEATURES',
  Gallery = 'GALLERY',
  View360 = 'VIEW360'
}
